import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    users: state.users,
    accountId: state.users.currentUser.Id,
    currentUser: state.users.currentUser,
    depotId:
      state.users.currentUser.Depots && state.users.currentUser.Depots.length
        ? state.users.currentUser.Depots[0]
        : null,
    deposts: state.users.currentUser.Depots,
  };
}

function mapDispatchToProps() {
  return {};
}

export const usersConnector = connect(mapStateToProps, mapDispatchToProps);
